export const CATALOGUE_FILTERS_KEY = 'catalogue-filters';
export const CATALOGUE_FILTERS_INTERACTED_KEY = 'catalogue-filters-interacted';
export const CSV_UPLOAD_ERRORS_KEY = 'csvUploadErrors';
